import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {StyledAmountTd} from './style';
import {L} from "bukku/redux/List/reducer";
import {formatNumber} from '../../../FormatNumber';
import {useListManager} from "../../../../redux/List/helper";
import { ConditionalTooltip } from '../../../Tooltip/ConditionalTooltip';

function AmountTd(props) {
    const {
        amount, currency_code, currency_symbol, currencies, className, wrapper, doNotReadLists,
        dp, dp2, style, showTooltip,
        valueWrapper,
    } = props;

    const listManager = useListManager([L.currencies]);

    useEffect(() => {
        if (currency_code && listManager.notRequested() && !doNotReadLists)
            listManager.readLists();
    }, [currency_code, currencies.length, listManager, doNotReadLists]);

    let symbol = currency_symbol;
    if (currency_code) {
        const currency = currencies?.find(c => c.code === (currency_code));
        symbol = currency?.symbol || currency_code;
    }

    if (amount === null || amount === undefined)
        return '-';

    const formattedAmount = formatNumber(amount, dp || dp === 0 ? dp : 2, dp2, true);

    const parsedValueWrapper = valueWrapper || wrapper;
    const content = (className = null) => (
        <span className={className}>
            <span className="currency">
                {wrapper ? wrapper(symbol) : symbol}
            </span>
            <span className="value">
                {parsedValueWrapper ? parsedValueWrapper(formattedAmount) : formattedAmount}
            </span>
        </span>
    );

    const contentDOM = (
        <ConditionalTooltip
            rules={[{
                condition: showTooltip,
                message: symbol ? `${symbol} ${formattedAmount}` : formattedAmount,
            }]}
            placement="topRight"
        >
            {content('amount-td')}
        </ConditionalTooltip>
    );

    return (
        <StyledAmountTd className={className} style={style}>
            {contentDOM}
        </StyledAmountTd>
    );
}

export const AmountTdWidth = 135;

AmountTd.defaultProps = {
    doNotReadLists: false,
    style: {},
};

export default connect(state => ({
    currencies: state.List.currencies,
}), {
})(AmountTd);
